import { z } from '@hono/zod-openapi'
import { heroSlidesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertHeroSlide = z.infer<typeof zInsertHeroSlide>
export type SelectHeroSlide = z.infer<typeof zSelectHeroSlide>
export type UpdateHeroSlide = z.infer<typeof zUpdateHeroSlide>
export type QueryHeroSlides = z.infer<typeof zQueryHeroSlides>
export type ColumnsOfHeroSlidesTable = keyof typeof heroSlidesTable._.columns

export const zSelectHeroSlide = createSelectSchema(heroSlidesTable)
export const zInsertHeroSlide = createInsertSchema(heroSlidesTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateHeroSlide = zInsertHeroSlide.partial()
export const zQueryHeroSlides = zInsertHeroSlide
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
